<template>
    <page :showBackButton="true">
        <!-- <template v-slot:header>
      <ion-title>Unwetterwarnung</ion-title>
    </template> -->

        <contract-card
            :contractId="contractId"
            feature="Unwetter"
            :shouldPresentContractSwitcherModal="
                shouldPresentContractSwitcherModal
            "
        ></contract-card>

        <h2>Unwetterwarnung</h2>
        Erhalte eine Unwetterwarnung per SMS für deine angegebene PLZ.
        <span v-if="hasSchadensmeldung"
            >Zusätzlich erhältst du nach einem schweren Unwetter eine
            OK-Nachricht via SMS mit der Frage, ob alles in Ordnung ist und
            einen Link zur Online Schadensmeldung.</span
        >

        <!-- <div v-if="Object.keys(devices).length > 0">
            <div class="ion-padding-top ion-margin-top">
                <b>Aktive Mobilgeräte</b>
            </div>
            <ion-list>
                <ion-item lines="full">
                    <ion-grid>
                        <ion-row>
                            <ion-col size="6">
                                Gerätename
                            </ion-col>
                            <ion-col size="4">
                                PLZ
                            </ion-col>
                            <ion-col size="2"> </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-item>
                <ion-item
                    v-for="(device, key) in devices"
                    lines="full"
                    :key="key"
                >
                    <ion-grid>
                        <ion-row class="ion-align-items-center">
                            <ion-col size="6">
                                {{ device.DeviceName
                                }}<sup v-if="device.DeviceId === deviceid">
                                    dieses&nbsp;Gerät</sup
                                >
                            </ion-col>
                            <ion-col size="4">
                                {{ device.DevicePlz }}
                            </ion-col>
                            <ion-col size="2">
                                <ion-button
                                    fill="clear"
                                    color="dark"
                                    @click="
                                        removeDevice(
                                            device.DeviceId,
                                            device.DeviceType
                                        )
                                    "
                                >
                                    <ion-icon
                                        name="trash"
                                        slot="icon-only"
                                    ></ion-icon>
                                </ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-item>
            </ion-list>
        </div> -->
        <div class="ion-padding-top">
            <b>Daten für SMS-Unwetterservice</b>
        </div>
        <form
            @submit.prevent="addDevice()"
            class="u-form-p-bottom"
            v-if="!isActive || showChangeForm"
        >
            <base-input
                id="mobil"
                v-model="mobil"
                type="tel"
                label="Handynummer"
                :mask="{ mask: '+000000000000000' }"
                infoText="Die Handynummer muss im Format +436641234567 eingegeben werden."
                placeholder="+43/Vorwahl/Nummer"
            ></base-input>
            <base-input
                id="plz"
                inputmode="decimal"
                type="number"
                v-model="plzSearch"
                label="PLZ"
                :debounce="300"
            ></base-input>
            <ion-list v-if="showPlzList">
                <ion-item
                    v-for="(plz, index) in plzArray"
                    :key="index"
                    @click="setPlz(plz)"
                    button
                >
                    <ion-label>{{ plz }}</ion-label>
                </ion-item>
                <ion-item v-if="plzArray.length === 0">
                    <ion-label
                        >Bitte gib eine gültige Postleitzahl an.</ion-label
                    >
                </ion-item>
            </ion-list>
            <template v-else>
                <!-- <base-checkbox
                    class="ion-margin-top"
                    v-model="okmessage"
                    id="okmessage"
                    lines="none"
                    label="Möchtest du eine „Bist du Ok?“ Nachricht per SMS nach einem Unwetter erhalten? In der SMS erhältst du dann einen direkten Link zur Schadensmeldung und sparst dir somit Zeit. (Text von Gangl Jakob - Bitte um Definition)"
                ></base-checkbox> -->
                <base-checkbox
                    v-if="!showChangeForm"
                    v-model="datenschutz"
                    id="datenschutz"
                    lines="none"
                    class="ion-margin-top"
                >
                    Ich stimme den
                    <a href="#" @click.prevent="openInfoModal()"
                        >Teilnahmebedingungen</a
                    >
                    der Unwetterwarnung zu.
                </base-checkbox>
                <div class="ion-margin-top">
                    <ion-button
                        expand="block"
                        @click="addDevice()"
                        :disabled="mobil === '' || plz === '' || !datenschutz"
                        v-if="!showChangeForm"
                    >
                        Anmelden
                    </ion-button>
                    <ion-grid v-else>
                        <ion-row>
                            <ion-col size="6">
                                <ion-button
                                    expand="block"
                                    @click="showChangeForm = false"
                                    fill="outline"
                                >
                                    Abbrechen
                                </ion-button>
                            </ion-col>
                            <ion-col size="6">
                                <ion-button
                                    expand="block"
                                    @click="addDevice()"
                                    :disabled="mobil === '' || plz === ''"
                                >
                                    Speichern
                                </ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </div>
            </template>
        </form>
        <ion-list v-else class="ion-margin-top">
            <ion-item>
                <ion-label>Handynummer</ion-label>
                <b slot="end">{{ mobilActive }}</b>
            </ion-item>
            <ion-item>
                <ion-label>PLZ</ion-label>
                <b slot="end">{{ plzActive }}</b>
            </ion-item>
            <!-- <ion-item>
                <ion-label>„Bist du Ok?“ Nachricht</ion-label>
                <b slot="end">{{ okMessageActive ? "Aktiv" : "Inaktiv" }}</b>
            </ion-item> -->
            <ion-grid class="ion-margin-top">
                <ion-row>
                    <ion-col size="6">
                        <ion-button
                            expand="block"
                            fill="outline"
                            @click="deactivate()"
                            >Abmelden</ion-button
                        >
                    </ion-col>
                    <ion-col size="6">
                        <ion-button expand="block" @click="changeData()"
                            >Daten ändern</ion-button
                        >
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-list>
        <!-- <div class="ion-margin-top" v-else>
            Zur Unwetterwarnung können Mobilgeräte nur direkt in der App
            hinzugefügt werden. Falls du die App noch nicht besitzt, kannst du
            diese ganz einfach im
            <a
                href="https://play.google.com/store/apps/details?id=at.wuestenrot.klickmal.app"
                target="_blank"
                >Google Play Store</a
            >
            für Android oder im
            <a href="https://apps.apple.com/at/app/id1501348909" target="_blank"
                >Apple App Store</a
            >
            für iOS herunterladen.
        </div> -->
    </page>
</template>

<script>
import Page from "@/components/Page";
import ContractCard from "@/components/ContractCard";
import { unwetterSetStatus, unwetterDeactivate } from "@/api/unwetterwarnung";
import BaseInput from "@/components/BaseInput";
// import { Plugins } from "@capacitor/core";
import { getPLZs } from "@/api/address";
import BaseCheckbox from "@/components/BaseCheckbox";
// import { BASEURL } from "@/utils/globals";
import InfoModal from "@/components/InfoModal";

// const { Browser } = Plugins;

export default {
    components: { Page, BaseInput, ContractCard, BaseCheckbox },
    props: {
        contractId: {
            required: false,
            type: String,
            default: "",
        },
        shouldPresentContractSwitcherModal: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    watch: {
        userDetails() {
            this.fillUserDetails();
        },
        plzSearch(newPlz) {
            if (newPlz !== "" && newPlz !== this.plz) {
                getPLZs(newPlz).then((response) => {
                    if (response.data.Status === 200) {
                        this.plzArray = [];
                        for (let plz in response.data.Result) {
                            this.plzArray.push(plz);
                        }
                        if (
                            this.plzArray.length === 1 &&
                            newPlz === this.plzArray[0]
                        ) {
                            this.setPlz(newPlz);
                        } else {
                            this.showPlzList = true;
                        }
                    }
                });
            } else {
                this.setPlz(newPlz);
            }
        },
    },
    data() {
        return {
            devicename: "",
            plz: "",
            deviceid: "",
            devicetype: "",
            isNative: Capacitor.isNative,
            mobil: "",
            plzSearch: "",
            showPlzList: false,
            plzArray: [],
            showChangeForm: false,
            datenschutz: false,
            // baseurl: BASEURL,
            // okmessage: false,
        };
    },
    mounted() {
        // this.setDeviceInfos();
        if (this.contractId !== "") {
            this.fillUserDetails();
            this.$store.dispatch(
                "unwetterwarnungen/unwetterGetStatus",
                this.contractId
            );
        }
    },
    methods: {
        openInfoModal() {
            this.$ionic.modalController
                .create({
                    component: InfoModal,
                    componentProps: {
                        propsData: {
                            id: "Unwetter-Teilnahme",
                            title: "Teilnahmebedingungen",
                            buttonText: "Schließen",
                        },
                        parent: this,
                    },
                })
                .then((m) => m.present());
        },
        fillUserDetails() {
            if ("plz" in this.userDetails) {
                this.setPlz(this.userDetails.plz);
            }
            if ("telefon" in this.userDetails) {
                this.mobil = this.userDetails.telefon.replace("/", "");
            }
        },
        setPlz(plz) {
            this.showPlzList = false;
            // if (plz !== this.plz) {
            this.plzSearch = plz;
            this.plz = plz;
            // }
        },
        deactivate() {
            this.$ionic.alertController
                .create({
                    header: "Abmelden",
                    message:
                        "Möchtest du dich wirklich vom SMS-Unwetterservice abmelden?",
                    buttons: [
                        {
                            text: "Nein",
                            role: "cancel",
                        },
                        {
                            text: "Ja",
                            handler: () => {
                                this.$store.commit("setLoading", true);
                                unwetterDeactivate(this.contractId).then(
                                    (response) => {
                                        if (response.data.Status === 200) {
                                            this.fillUserDetails();
                                            this.$store.commit(
                                                "setLoading",
                                                true
                                            );
                                            this.$store.dispatch(
                                                "unwetterwarnungen/unwetterGetStatus",
                                                this.contractId
                                            );
                                            this.$ionic.alertController
                                                .create({
                                                    header:
                                                        "Abmeldung erfolgreich",
                                                    message:
                                                        "Du hast dich erfolgreich von der SMS-Unwetterwarnung abgemeldet. Innerhalb der nächsten 24 Stunden werden deine Angaben hier angezeigt.",
                                                    buttons: ["Verstanden"],
                                                })
                                                .then((a) => {
                                                    a.present();
                                                });
                                        }
                                    }
                                );
                            },
                        },
                    ],
                })
                .then((a) => a.present());
        },
        addDevice() {
            this.$store.commit("setLoading", true);
            unwetterSetStatus({
                vertragsnummer: this.contractId,
                plz: this.plz,
                mobil: this.mobil,
                // okmessage: this.okmessage,
            }).then((response) => {
                if (response.data.Status === 200) {
                    this.mobil = "";
                    this.setPlz("");
                    this.showChangeForm = false;
                    this.$store.commit("setLoading", true);
                    this.$store.dispatch(
                        "unwetterwarnungen/unwetterGetStatus",
                        this.contractId
                    );
                    this.$ionic.alertController
                        .create({
                            header: "Anmeldung erfolgreich",
                            message:
                                "Perfekt! Du hast dich erfolgreich für die SMS-Unwetterwarnung angemeldet. Innerhalb der nächsten 24 Stunden werden deine Angaben hier angezeigt.",
                            buttons: ["Verstanden"],
                        })
                        .then((a) => {
                            a.onDidDismiss().then(() => {
                                this.$store.commit("setAskForRating", true);
                            });
                            a.present();
                        });
                }
            });
        },
        changeData() {
            this.showChangeForm = true;
            this.mobil = this.mobilActive;
            this.setPlz(this.plzActive);
        },
        // async setDeviceInfos() {
        //     const info = await Device.getInfo();
        //     if ("platform" in info) {
        //         this.devicetype = info.platform;
        //     }
        //     if ("name" in info) {
        //         this.devicename = info.name;
        //     } else {
        //         let manufacturerAndModel = "";
        //         if ("manufacturer" in info) {
        //             manufacturerAndModel += info.manufacturer;
        //         }
        //         if ("model" in info) {
        //             manufacturerAndModel += " " + info.model;
        //         }
        //         this.devicename = manufacturerAndModel;
        //     }
        // },
    },
    computed: {
        hasSchadensmeldung() {
            let result = false;
            if (
                this.contractId &&
                this.$store.state.contracts[this.contractId] &&
                this.$store.state.contracts[this.contractId].Features
                    .Schadensmeldung &&
                this.$store.state.contracts[this.contractId].Features
                    .Schadensmeldung === true
            ) {
                result = true;
            }
            return result;
        },
        userDetails() {
            return this.$store.state.user.details;
        },
        unwetterwarnungen() {
            return this.$store.state.unwetterwarnungen.all;
        },
        isActive() {
            let result = false;
            if (
                this.contractId in this.unwetterwarnungen &&
                this.unwetterwarnungen[this.contractId].Active
            ) {
                result = true;
            }
            return result;
        },
        mobilActive() {
            let result = "";
            if (
                this.contractId in this.unwetterwarnungen &&
                this.unwetterwarnungen[this.contractId].Mobil
            ) {
                result = this.unwetterwarnungen[this.contractId].Mobil;
            }
            return result;
        },
        plzActive() {
            let result = "";
            if (
                this.contractId in this.unwetterwarnungen &&
                this.unwetterwarnungen[this.contractId].Plz
            ) {
                result = this.unwetterwarnungen[this.contractId].Plz;
            }
            return result;
        },
        // okMessageActive() {
        //     let result = "";
        //     if (
        //         this.contractId in this.unwetterwarnungen &&
        //         this.unwetterwarnungen[this.contractId].OkMessageActive
        //     ) {
        //         result = this.unwetterwarnungen[this.contractId]
        //             .OkMessageActive;
        //     }
        //     return result;
        // },
    },
};
</script>

<style lang="scss">
ion-list {
    ion-item {
        --padding-start: 0;
    }
}
</style>
